import { render, staticRenderFns } from "./ComparisonSkeleton.vue?vue&type=template&id=3411d9fd&"
import script from "./ComparisonSkeleton.vue?vue&type=script&lang=js&"
export * from "./ComparisonSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonSkeleton.vue?vue&type=style&index=0&id=3411d9fd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports